/**
 * Tabs of a platform's work area (`/platforms/{code}/{tab}`). Apart from the component so the layout can offer them to
 * the AI assistant as screens without loading the platform screen.
 */

/** Pestañas de la zona de trabajo. Se nombran aquí para que una errata sea error de compilación. */
export type WiringTab = 'general' | 'common-services' | 'applications' | 'deployment' | 'capabilities' | 'plans' | 'maintenance' | 'themes';

/**
 * Tabs in the order and groups they are shown: what the platform is, what runs on it, and how it is sold and
 * operated. Themes go with the applications: they are chosen per application.
 */
export const WIRING_TAB_GROUPS: readonly (readonly WiringTab[])[] = [
  ['general', 'common-services', 'capabilities'],
  ['deployment', 'applications', 'themes'],
  ['plans', 'maintenance'],
];

export const WIRING_TABS: readonly WiringTab[] = WIRING_TAB_GROUPS.flat();

export const WIRING_TAB_LABELS: Readonly<Record<WiringTab, string>> = {
  general: 'BACKOFFICE.PLATFORM_WIRING.TAB_GENERAL',
  'common-services': 'BACKOFFICE.PLATFORM_WIRING.TAB_COMMON_SERVICES',
  capabilities: 'BACKOFFICE.PLATFORM_WIRING.TAB_CAPABILITIES',
  deployment: 'BACKOFFICE.PLATFORM_WIRING.TAB_DEPLOYMENT',
  applications: 'BACKOFFICE.PLATFORM_WIRING.TAB_APPLICATIONS',
  themes: 'BACKOFFICE.PLATFORM_WIRING.TAB_THEMES',
  plans: 'BACKOFFICE.PLATFORM_WIRING.TAB_PLANS',
  maintenance: 'BACKOFFICE.PLATFORM_WIRING.TAB_MAINTENANCE',
};
